import { Box, Text, Tooltip } from '@mantine/core';
import { IconCircleFilled } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  GesStatusValue,
  getGesStatusCssColor,
  getGesStatusI18nKey,
  getGesStatusMeta,
  parseGesStatus,
} from '../utils/ges-status';

interface GesStatusIconProps {
  value: GesStatusValue;
}

export const GesStatusIcon: FC<GesStatusIconProps> = ({ value }) => {
  const { t } = useTranslation();
  const status = parseGesStatus(value);
  const meta = getGesStatusMeta(value);
  const color = getGesStatusCssColor(value);

  if (status == null || !color || !meta) {
    return <Text size="sm">-</Text>;
  }

  return (
    <Tooltip label={t(getGesStatusI18nKey(status))} position="top">
      <Box style={{ display: 'inline-flex', alignItems: 'center' }}>
        <IconCircleFilled color={color} size={30} />
      </Box>
    </Tooltip>
  );
};
